import { CardProps } from 'components/molecules/Card';
import CardDetailWorkout from 'components/molecules/Card/Detail/Workout';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators as optionalProgramItemsAC } from 'store/optionalProgramItems';
import { getWeight } from 'store/profile';
import { actionCreators as itemAC } from 'store/programItems';
import {
	getDescriptionFromSelectedContent,
	getDescriptionShortFromSelectedContent,
	getIntensityFromSelectedContent,
	getPausePerWorkoutSetFromSelectedContent,
	getRepetitionsPerWorkoutSetFromSelectedContent,
	getTitleFromSelectedContent,
	getToolListFromSelectedContent,
	getWorkoutCaloriesFromSelectedContent,
	getWorkoutSetsFromSelectedContent,
	getWorkoutTotalDurationFromSelectedContent,
} from 'store/programItems';
import { actionCreators as transientPoolAC } from 'store/transientPoolState';

const mapStateToProps = (state: any, ownProps: CardProps & any) => {
	const selectedContent = ownProps.parentProps;

	return {
		title: getTitleFromSelectedContent(selectedContent),
		isDone: false,
		intensity: getIntensityFromSelectedContent(selectedContent),
		energyKcal: ((calories: number, profileWeight: number) => {
			if (!calories || !profileWeight) {
				return 0;
			}
			return calories * profileWeight;
		})(getWorkoutCaloriesFromSelectedContent(selectedContent), getWeight(state)!),
		totalDuration: getWorkoutTotalDurationFromSelectedContent(selectedContent),
		descriptionShort: getDescriptionShortFromSelectedContent(selectedContent),
		description: getDescriptionFromSelectedContent(selectedContent),
		toolList: getToolListFromSelectedContent(selectedContent),
		tableList: { items: getWorkoutSetsFromSelectedContent(selectedContent) },
		repetitionsPerWorkoutSet: getRepetitionsPerWorkoutSetFromSelectedContent(selectedContent),
		pausePerWorkoutSet: getPausePerWorkoutSetFromSelectedContent(selectedContent),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...itemAC,
			doSetProgramItemRef: transientPoolAC.doSetProgramItemRef,
			doCreateItem: optionalProgramItemsAC.doCreateItem,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(CardDetailWorkout as any);
